export default __webpack_public_path__ + "static/equilibre_pasteur_logo-fcab4389b418b01f519d75febde8c454.png";